/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AdminProductStatus = {
    ProductStatusDraft: 'draft',
    ProductStatusReadyForSale: 'ready_for_sale',
    ProductStatusActive: 'active',
    ProductStatusReserved: 'reserved',
    ProductStatusSold: 'sold',
    ProductStatusTookForThemself: 'took_for_themself',
    ProductStatusNeedReview: 'need_review'
} as const;
export type AdminProductStatus = typeof AdminProductStatus[keyof typeof AdminProductStatus];


export function instanceOfAdminProductStatus(value: any): boolean {
    for (const key in AdminProductStatus) {
        if (Object.prototype.hasOwnProperty.call(AdminProductStatus, key)) {
            if (AdminProductStatus[key as keyof typeof AdminProductStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AdminProductStatusFromJSON(json: any): AdminProductStatus {
    return AdminProductStatusFromJSONTyped(json, false);
}

export function AdminProductStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProductStatus {
    return json as AdminProductStatus;
}

export function AdminProductStatusToJSON(value?: AdminProductStatus | null): any {
    return value as any;
}

export function AdminProductStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): AdminProductStatus {
    return value as AdminProductStatus;
}

